import { render, staticRenderFns } from "./FavoriteIcon.vue?vue&type=template&id=bdde132c"
import script from "./FavoriteIcon.vue?vue&type=script&lang=js"
export * from "./FavoriteIcon.vue?vue&type=script&lang=js"
import style0 from "./FavoriteIcon.vue?vue&type=style&index=0&id=bdde132c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports